import { FC } from 'react'
import { BasicStyledComponent, DSPageSection } from 'shared-definitions/types'
import styles from './TocMenuSubMenu.module.css'
import clsx from 'clsx'

interface TocMenuSubMenuProps extends BasicStyledComponent {
  size: 'large' | 'medium'
  showSidebar?: boolean
  sectionItems: readonly DSPageSection[]
  onMenuItemClick?: (section: DSPageSection) => void
  currentSection: DSPageSection | null
}

const TocMenuSubMenu: FC<TocMenuSubMenuProps> = ({
  currentSection,
  size,
  className,
  sectionItems,
  onMenuItemClick,
  showSidebar,
}) => (
  <ul
    className={clsx(styles.container, className, {
      [styles.large]: size === 'large',
      [styles.medium]: size === 'medium',
      [styles.showSidebar]: showSidebar,
    })}
  >
    {sectionItems.map((section, index) => (
      <li
        key={index}
        className={clsx({
          [styles.large]: size === 'large',
          [styles.medium]: size === 'medium',
        })}
      >
        <a
          href={`#${section.anchor}`}
          rel="nofollow"
          onClick={e => {
            onMenuItemClick?.(section)

            const el = document.getElementById(section.anchor)
            if (el) {
              e.preventDefault()
              el.scrollIntoView({ behavior: 'smooth', block: 'start' })
            }
          }}
          className={clsx(styles.button, {
            [styles.activeItem]: currentSection?.anchor === section.anchor,
          })}
        >
          {section.label}
        </a>
        {section.children.length > 0 && (
          <TocMenuSubMenu
            showSidebar
            currentSection={currentSection}
            size="medium"
            sectionItems={section.children}
            onMenuItemClick={onMenuItemClick}
          />
        )}
      </li>
    ))}
  </ul>
)

export default TocMenuSubMenu
